angular.module('impactx.search').component('ixCardPane', {
        require: {
            containerCtrl: '^ixCardTabContainer'
        },
        bindings: {
            heading: '@',
            icon: '@',
            showAllRoute: '@',
            amount: '@',
            actualAmount: '<',
            cardWidth: '@',
            data: "=",
            trns: "=",
            usePreSetRoute: "=",
            showListIcon: "<",
            selected: "<",
            onContentUpdate: "&",
            currentFilter: "="
        },
        controller: 'CardPaneCtrl',
        controllerAs: 'paneCtrl',
        templateUrl: 'modules/search/templates/card-pane.html',
        transclude: true
    }
);